import typography from "../typography"

export default {
  root: {
    ...typography.body1,
  },
}
